import { IBridge } from 'legacy/lut/classes/models/partner360/IBridge'
import { v4 as uuid4 } from 'uuid'

import { IBridgeWithUuid } from '../models/iCalculatedBridge'

export const assignUuidToBridge = (item: IBridge): IBridgeWithUuid => {
  return {
    ...structuredClone(item),
    uuid: uuid4(),
  }
}
